import React from 'react';
import { injectIntl } from 'react-intl';
import { Form } from '@ant-design/compatible';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import { getPaymentMessages, getReportMessages } from '../../../../constants/messages';
import { getPaymenTypeList, TYPES } from '../../../Payments/constants';
import '@ant-design/compatible/assets/index.css';
const { Option } = Select;
const { PAYMENT } = TYPES;

let reportMessages = getReportMessages(),
	paymentMessages = getPaymentMessages();

const messages = {
	...reportMessages,
	...paymentMessages,
};

const FormItem = Form.Item;

class Type extends React.Component {
	getIntl = (str) => this.props.intl.formatMessage({ ...messages[str] });

	render() {
		const { props, getIntl } = this;
		const { getFieldDecorator } = props.form;
		const options = getPaymenTypeList().map(({ id, intl }) => (
			<Option key={id} value={id}>
				{getIntl(intl)}
			</Option>
		));
		return (
			<FormItem label={getIntl('typeOfPayment')}>
				{getFieldDecorator('type', { initialValue: PAYMENT.id })(
					<Select
						className="job-full-component"
						placeholder={getIntl('typeOfPayment')}
						dropdownMatchSelectWidth={false}
					>
						{options}
					</Select>
				)}
			</FormItem>
		);
	}
}

Type.propTypes = {
	intl: PropTypes.object.isRequired,
	form: PropTypes.object.isRequired,
};

export default injectIntl(Type);
